(function () {
  var DEFAULT_PRICE = 39;
  var ADDON_KEY = 'ciw-prism';

  function getConfig() {
    return window.ciwLaPrismUpgrade || {};
  }

  function getPrice() {
    var price = parseFloat(getConfig().price);
    return isNaN(price) ? DEFAULT_PRICE : price;
  }

  function formatUpgradePrice(price) {
    var cents = Math.round(price * 100);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify.theme && window.Shopify.theme.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }

    return '$' + (price % 1 === 0 ? price.toFixed(0) : price.toFixed(2));
  }

  function getCheckboxLabel() {
    return 'Add prism (+' + formatUpgradePrice(getPrice()) + ')';
  }

  function isActive() {
    var checkbox = document.querySelector(
      '.ciw-la-manual-rx-prism-toggle .ciw-la-manual-rx-checkbox__input'
    );
    if (checkbox) {
      return checkbox.checked;
    }

    var yesRadio = document.querySelector('#la-prism-field-dual');
    return !!(yesRadio && yesRadio.checked);
  }

  function getAmount() {
    return isActive() ? getPrice() : 0;
  }

  function syncCustomAddOn(la, amount) {
    if (!la) {
      return;
    }

    la.customAddOns = (la.customAddOns || []).filter(function (item) {
      return item && item.name !== ADDON_KEY;
    });

    if (amount <= 0) {
      return;
    }

    var config = getConfig();
    la.customAddOns.push({
      name: ADDON_KEY,
      productTitle: 'Prism',
      price: String(amount),
      productId: config.productId || '',
      variantId: config.variantId || '',
      canSkip: false,
      properties: {}
    });
  }

  function applyToLensAdvizor(la) {
    if (!la || !la.prices) {
      return 0;
    }

    var amount = getAmount();
    var prev = la.__ciwPrismUpgradeAmount || 0;
    la.__ciwPrismUpgradeAmount = amount;
    syncCustomAddOn(la, amount);

    if (prev !== amount) {
      la.prices.addons = (la.prices.addons || 0) - prev + amount;
      la.prices.subtotal = (la.prices.subtotal || 0) - prev + amount;
    }

    return amount;
  }

  function removeReviewRows() {
    document.querySelectorAll('.ciw-la-prism-review-block').forEach(function (node) {
      node.remove();
    });
  }

  function findReviewAddOnsHeader(wrapper) {
    var headers = wrapper.querySelectorAll('.la-review-item .la-label-title strong');
    for (var i = 0; i < headers.length; i++) {
      if (/add\s*ons/i.test(String(headers[i].textContent || '').trim())) {
        return headers[i].closest('.la-review-item');
      }
    }
    return null;
  }

  function buildReviewRow(amount) {
    var block = document.createElement('div');
    block.className = 'ciw-la-prism-review-block';
    block.innerHTML =
      '<div class="la-review-item la-flex-start ciw-la-prism-review-row">' +
      '<div class="la-review-left">' +
      '<div class="la-label-description">Prism</div>' +
      '</div>' +
      '<div class="la-review-right la-label-title">' +
      formatUpgradePrice(amount) +
      '</div>' +
      '</div>';
    return block;
  }

  function buildReviewSection(amount) {
    var block = document.createElement('div');
    block.className = 'ciw-la-prism-review-block';
    block.innerHTML =
      '<div class="la-review-item">' +
      '<div class="la-review-left">' +
      '<div class="la-label-title"><strong>Add Ons</strong></div>' +
      '</div>' +
      '</div>' +
      '<div class="la-review-item la-flex-start ciw-la-prism-review-row">' +
      '<div class="la-review-left">' +
      '<div class="la-label-description">Prism</div>' +
      '</div>' +
      '<div class="la-review-right la-label-title">' +
      formatUpgradePrice(amount) +
      '</div>' +
      '</div>' +
      '<div class="la-divider"></div>';
    return block;
  }

  function syncReviewRow() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
      return;
    }

    var wrapper = document.querySelector('.la-review-details-wrapper');
    removeReviewRows();

    if (!wrapper) {
      return;
    }

    var amount = getAmount();
    if (amount <= 0) {
      return;
    }

    var addOnsHeader = findReviewAddOnsHeader(wrapper);
    if (addOnsHeader) {
      var rowBlock = buildReviewRow(amount);
      var cursor = addOnsHeader.nextElementSibling;
      var divider = null;
      while (cursor) {
        if (cursor.classList.contains('la-divider')) {
          divider = cursor;
          break;
        }
        if (
          cursor.classList.contains('la-review-item') &&
          cursor.querySelector('.la-label-title strong')
        ) {
          break;
        }
        cursor = cursor.nextElementSibling;
      }
      wrapper.insertBefore(rowBlock, divider || cursor);
      return;
    }

    var anchor = wrapper.querySelector('.la-order-notes-wrapper');
    var section = buildReviewSection(amount);
    if (anchor) {
      wrapper.insertBefore(section, anchor);
    } else {
      wrapper.appendChild(section);
    }
  }

  function syncPricing() {
    var la = window.LensAdvizor;
    if (la && typeof la.updateFooterPrices === 'function') {
      la.updateFooterPrices();
    } else {
      syncReviewRow();
    }

    document.dispatchEvent(new CustomEvent('ciw-la-prism:changed'));
  }

  function patchLensAdvizorPricing() {
    if (!window.LensAdvizor || typeof LensAdvizor.updateFooterPrices !== 'function') {
      return false;
    }
    if (LensAdvizor.__ciwPrismUpgradePatched) {
      return true;
    }

    LensAdvizor.__ciwPrismUpgradePatched = true;
    var original = LensAdvizor.updateFooterPrices.bind(LensAdvizor);
    LensAdvizor.updateFooterPrices = function () {
      var result = original.apply(this, arguments);
      applyToLensAdvizor(this);
      syncReviewRow();
      return result;
    };

    return true;
  }

  function bind() {
    document.addEventListener('LensAdvizor:review:rendered', function () {
      window.setTimeout(syncReviewRow, 0);
    });

    document.addEventListener('change', function (event) {
      if (
        event.target.matches(
          '.ciw-la-manual-rx-prism-toggle .ciw-la-manual-rx-checkbox__input, #la-prism-field-dual, #la-prism-field-single'
        )
      ) {
        window.setTimeout(syncPricing, 0);
      }
    });

    var wait = window.setInterval(function () {
      if (patchLensAdvizorPricing()) {
        window.clearInterval(wait);
        syncPricing();
      }
    }, 250);

    window.setTimeout(function () {
      window.clearInterval(wait);
    }, 30000);
  }

  window.ciwLaPrismUpgradeApi = {
    getAmount: getAmount,
    getCheckboxLabel: getCheckboxLabel,
    applyToLensAdvizor: applyToLensAdvizor,
    syncPricing: syncPricing,
    syncReviewRow: syncReviewRow
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
